import React from 'react'
import './Counterbox.css'
import CountUp from 'react-countup';
import Colimg from '../../assets/image-1.png'



export const Counterbox = () => {
  return (
    <div class="counter-section ws-section mb-5">
        <div class="container">
        <div class="row row-rev">
            <div class="col-lg-7 align-self-center mb-3">
                <div class="bg-3 dark-background-2 p-5 left-col">
            <div class="row">
                <div class="col-lg-9">
                    
                        <h2 class="ws-section_heading mb-5 pt-4">Join the Leaders in VLSI Design</h2>
                        <p class="pb-3">Join the leaders in VLSI Design and be part of cutting-edge innovation in semiconductor technology, where precision meets performance.
                        </p>
                        <div class="count-box mt-5">
                        <div class="row text-center">
                            <div class="col-lg-4 mb-5">
                            <CountUp end={12} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Years of Excellence</h5>
                            </div>
                            <div class="col-lg-4 mb-5">
                            <CountUp end={6} suffix="k  +" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Student Placed</h5>
                            </div>
                            <div class="col-lg-4 mb-5">
                            <CountUp end={30} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Trainers</h5>
                            </div>
                            <div class="col-lg-4 mb-5">
                            <CountUp end={8} suffix="k +" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Students enrolled</h5>
                            </div>
                            <div class="col-lg-4 mb-5">
                            <CountUp end={400} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Batches Complete</h5>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
            </div>
            </div>
            <div class="col-lg-5 align-self-start mb-3">
           <img src={Colimg} alt=''/>
            </div>
        </div>
        </div>
    </div>
  )
}
